import React from "react";
import { FaInfoCircle } from "react-icons/fa";

const ZOHO_REDIRECTION_NULL = "https://support.aakash.ac.in/portal/en/signin";

const style = {
  background: "#FCEEED",
  color: "#B32306",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  marginTop: "10px",
  borderRadius: "5px",
  paddingTop: "3px",
  paddingBottom: "3px",
};
const urlStyle = {
  fontFamily: "Gilroy-bold",
  fontWeight: "800",
  marginLeft: "20px",
  cursor: "pointer",
};

const ZohoRedirection = ({ dayCount }) => {
  const navigation = () => {
    window.open(ZOHO_REDIRECTION_NULL);
  };
  if (dayCount === null)
    return <div></div>
  if (dayCount >= 0) return <div></div>;
  return (
    <div style={style}>
      <FaInfoCircle /> {"  "}
      <span className="ml-2">Please raise a ticket to deposit</span>{" "}
      <span style={urlStyle} onClick={navigation}>
        {" "}
        Raise ticket →
      </span>
    </div>
  );
};

export default ZohoRedirection;
